import React, { useId, useState } from 'react';
import { AlternativeProduct } from 'src/components/ProductDetail/AlternativeProduct/AlternativeProduct';
import { Svg } from 'src/components/Svg/Svg';
import classnames from 'classnames';
import { AlternativeSku } from 'src/types/global-types';
import alternativeSkusQuery from 'src/queries/alternativeSkus.graphql';
import { useQuery } from '@apollo/client';
import camelcaseKeys from 'camelcase-keys';

import classes from './AlternateStock.scss';

type Props = {
    sku?: string;
    color?: string;
};

export const AlternateStock: React.FC<Props> = ({ sku, color }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const listId = useId();

    const { data } = useQuery(alternativeSkusQuery, {
        variables: {
            sku: sku,
            color: color,
        },
    });

    if (!data || !data?.alternativeSkus || data?.alternativeSkus.length <= 0) return null;

    const alternativeSkus: AlternativeSku[] = camelcaseKeys(data?.alternativeSkus, { deep: true });

    return (
        <div className={classnames(classes.alternateStock, { [classes.collapsed]: isCollapsed })}>
            <button
                type="button"
                className={classes.header}
                onClick={() => setIsCollapsed(!isCollapsed)}
                aria-expanded={!isCollapsed}
                aria-controls={listId}
            >
                <span>Or see similar products in stock</span>
                <span className={classnames(classes.arrow, { [classes.arrowUp]: !isCollapsed })}>
                    <Svg name="arrow-down" />
                </span>
            </button>
            <div id={listId} className={classes.alternativeSkus} inert={isCollapsed}>
                {alternativeSkus?.map((alternativeSku, key) => (
                    <AlternativeProduct key={key} alternativeSku={alternativeSku} />
                ))}
            </div>
        </div>
    );
};
